import Extensions from '../../extensions';
import Navigator from "../../global/navigator";
import Header from "../../global/header";
import Footer from "../../global/footer";
import initSeoStuff from './seo-stuff';

// import WidgetGiftCertificate from "./widgets/widget-gift-certificate";
// import WidgetIphone17 from "../page-modules/course-entry/widget-iphone-17";

import DOMHelper from "../../lib/dom-helper";
import ServiceLocator from "../../global/service-locator";
import LangSwitcher from "../../global/lang-switcher";
import SpecialEventQuiz from "../../components/special-event/special-event-quiz";
import SpecialEventPopup from "../../components/special-event/special-event-popup";
import FormController from "./form-controller";
import EnvHelper from "../../lib/env-helper";
// import NY26Modal from "../../components/ny-26/ny26-modal";
// import NY26Bar from "../../components/ny-26/ny26-bar";
// import Bf25Modal from "../../components/black-friday/2025/bf25-modal";

export default class CoreModule {
	constructor() {
		this.sl = ServiceLocator.instance;
		this.navigator = new Navigator();
		this.extensions = new Extensions();
		this.header = new Header();
		this.footer = new Footer();
		this.formController = new FormController();
		this.widgetIphone17 = null;
		this.NY26Modal = null;
		this.NY26Bar = null;

		initSeoStuff();

		this.initTooltips();
		// this.initWidgetGiftCertificate();
		// this.initWidgetIphone17();
		this.initLangSwitcher();
		this.initSpecialEvent();
		// this.initBF25Modal();
		// this.initNY26Modal();
		// this.initNY26Bar();
	}

	initTooltips() {
		DOMHelper.tooltips();
	}

	initWidgetIphone17() {
		// if (craft.env.dynamicHeader) {
		// 	this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
		// 		this.widgetIphone17 = new WidgetIphone17();
		// 	});
		// } else {
		// 	this.widgetIphone17 = new WidgetIphone17();
		// }
	}

	initBF25Modal() {
		// const handle = craft.page.handle;
		//
		// if (handle !== 'homepage' && handle !== "bf25") {
		// 	if (craft.env.dynamicHeader) {
		// 		this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
		// 			this.BF25Modal = new Bf25Modal();
		// 		});
		// 	} else {
		// 		this.BF25Modal = new Bf25Modal();
		// 	}
		// }
	}

	initNY26Modal() {
		// if (craft.env.dynamicHeader) {
		// 	this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
		// 		this.NY26Modal = new NY26Modal();
		// 	});
		// } else {
		// 	this.NY26Modal = new NY26Modal();
		// }
	}

	initNY26Bar() {
		// const handle = craft.page.handle;
		//
		// if (handle !== 'homepage') {
		// 	if (craft.env.dynamicHeader) {
		// 		this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
		// 			this.NY26Bar = new NY26Bar();
		// 		});
		// 	} else {
		// 		this.NY26Bar = new NY26Bar();
		// 	}
		// }
	}

	// initWidgetGiftCertificate() {
	// 	if (craft.env.dynamicHeader) {
	// 		this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
	// 			this.widgetGiftCertificate = new WidgetGiftCertificate();
	// 		});
	// 	} else {
	// 		this.widgetGiftCertificate = new WidgetGiftCertificate();
	// 	}
	// }

	initLangSwitcher() {
		const langSwitcher = new LangSwitcher();
	}

	initSpecialEvent() {
		if (EnvHelper.page.specialEventConfig == null || !EnvHelper.page.specialEventConfig.status) return;

		new SpecialEventPopup();
		new SpecialEventQuiz();
	}
}